<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>
          Images ({{ keys.length }}/{{ maxVariables }}):
          <br />
          <span class="disclaimer">Allowed dimensions are:</span>
          <br>
          <span class="disclaimer">1) 1200x628</span>
          <br>
          <span class="disclaimer">2) 1200x1200</span>
          <br>
          <span class="disclaimer">3) 960x1200</span>
          <br>
          <span class="disclaimer">4) 600x600</span>
        </div>

        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-12" *ngFor="let genSingleImageImageKey of keys">
          <app-block-text
            [type]="'link'"
            [isPlainText]="true"
            (handleOnChange)="onChange($event, genSingleImageImageKey)"
            (handleVariableRemoval)="variableRemoval($event)"
            [blockData]="block.variables?.[genSingleImageImageKey] ?? ''"
            [maxLength]="4000"
            [variable]="genSingleImageImageKey"
            [isSubBlockDeletable]="true"
            [isImage]="true"
          ></app-block-text>
        </div>
        <div class="col-12 mt-2">
          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            (click)="add()"
            [disabled]="!canAdd"
          >
            <i class="bi bi-plus-lg"></i>Add image
          </button>
        </div>
      </div>
    </div>
    <!-- <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side">
        <div class="row text-center">
          <div class="col-12" [innerHTML]="block.variables?.Headline_1"></div>
        </div>
      </div>
    </div> -->
    <!-- <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div> -->
  </div>
</main>
